
import { useSelector } from 'react-redux';
import MenuExpediente from './menuExpediente';
import MenuDmts from './menuImportacao';
import MenuDlifDesalfandegamento from './menuDlifDesalfandegamento';
import MenuDlifLicenciamento from './menuDlifLicenciamento';
import VerifyPermission from '../../../utils/verifyPermission';
import { makeStyles } from '@material-ui/core';
import MenuFarmacovigilancia from './menuFarmacovigilancia';
import MenuControleQualidade from './menuControleQualidade';
import MenuDmtsCertificadoProdutoControlado from './menuDmtsCertificadoProdutoControlado';
import { Alert, AlertTitle } from '@mui/material';
import MenuMedicamentos from './menuMedicamentos';


const useStyles = makeStyles((theme) => ({
  containerCardesService: {
    // minHeight: '50vh',
    padding: '1rem',
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'center',
    alignItems: 'center',
    gap: '2rem',
  }
}))

export default function Menus() {
  const classes = useStyles();
  const user = useSelector(state => state.account.user);

  const Header = ({ title, marginBottom }) => {
    return (
      <div style={{ margin: 40, marginBottom: marginBottom ?? '' }}>
        <h1 style={{ margin: 20, fontSize: 23 }}>
          {title}
        </h1>
        <hr style={{ border: '1px solid #85287e' }} />
      </div>
    )
  }

  return (
    <>
      {user?.permissions?.length === 0 &&
        <Alert severity="warning" style={{ margin: 20 }}>
          <AlertTitle>{'Usuario(a) está sem privilégios no sistema.!'}</AlertTitle>
        </Alert>
      }

      <VerifyPermission permissions={user?.permissions} permission={'secçãoLicenciamento'} verificacaoSimples={true}>
        <section>
          <Header title={'LICENCIAMENTO'} />
          <MenuDlifLicenciamento styles={classes.containerCardesService} />
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoCertificadoProdutoControlo'} verificacaoSimples={true}>
        <Header title={'CERTIFICADOS PARA PRODUTO CONTROLADO'} />
        <MenuDmtsCertificadoProdutoControlado styles={classes.containerCardesService} />
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoImportação'} verificacaoSimples={true}>
        <Header title={'IMPORTAÇÃO'} />
        <MenuDmts styles={classes.containerCardesService} />
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoDesalfandegamento'} verificacaoSimples={true}>
        <section>
          <Header title={'DESALFANDEGAMENTO'} />
          <MenuDlifDesalfandegamento styles={classes.containerCardesService} />
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoExpediente'} verificacaoSimples={true}>
        <section>
          <Header title={'EXPEDIENTE'} marginBottom={20} />
          <MenuExpediente styles={classes.containerCardesService} />
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoControleQualidade'} verificacaoSimples={true}>
        <section>
          <Header title={'CONTROLE DE QUALIDADE'} />
          <MenuControleQualidade styles={classes.containerCardesService} />
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoFarmacovigilância'} verificacaoSimples={true}>
        <section>
          <Header title={'FARMACOVIGILÂNCIA'} />
          <MenuFarmacovigilancia styles={classes.containerCardesService} />
        </section>
      </VerifyPermission>

      <VerifyPermission permissions={user?.permissions} permission={'secçãoMedicamentos'} verificacaoSimples={true}>
        <section>
          <Header title={'MEDICAMENTOS'} />
          <MenuMedicamentos styles={classes.containerCardesService} />
        </section>
      </VerifyPermission>
    </>
  )
}





